import React from 'react'
import styled, { keyframes } from 'styled-components'

const fadeInUp = keyframes`
  from {
    transform: translate3d(0, 100px, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`

const Wrapper = styled.div`
  animation: ${props => props.animating ? `${fadeInUp} .5s ease forwards` : 'none'};
  animation-delay: ${ props => props.delay ? props.delay : 0}s;
`
/* HACK: Toggling the animation property is necessary because transforming an element redefines
 * its coordinate system. As a result fixed/absolute elements are positioned relative to that
 * element instead of the nearest relatively positioned parent. To prevent this, we need to
 * make sure the transform property on this wrapper is set to "none" after the animation completes.
 */
export default class FadeInUpWrapper extends React.Component {
  constructor() {
    super()
    this.state = {
      animating: true
    }
  }
  onAnimationEnd = () => {
    this.setState({
      animating: false
    })
  }
  render() {
    return (
      <Wrapper onAnimationEnd={this.onAnimationEnd} className={this.props.className} animating={this.state.animating}>
        {this.props.children}
      </Wrapper>
    )
  }
}
